import { apiCall } from "../base";
import { HttpMethod } from "@/types/https";
import {
  TechnicianResponse,
  TechnicianSingleResponse,
  GroupedTechnician,
  TechnicianConflictResponse
} from "../types/technicians.type";
import { ENDPOINT } from "../endpoint";

export const TechnicianList = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `TechnicianList_${stringParams}`,
    handle: (): Promise<TechnicianResponse> =>
      apiCall<TechnicianResponse>({
        params,
        url: ENDPOINT.TECHNICIANS,
        method: HttpMethod.GET
      })
  };
};

export const CreateTechnician = () => ({
  name: "CreateTechnician",
  handle: (technicianData: any): Promise<TechnicianResponse> =>
    apiCall<TechnicianResponse>({
      url: ENDPOINT.TECHNICIANS,
      method: HttpMethod.POST,
      body: technicianData
    })
});

export const UpdateTechnician = (technicianId: string) => ({
  name: `UpdateTechnician_${technicianId}`,
  handle: (technicianData: any): Promise<TechnicianResponse> =>
    apiCall<TechnicianResponse>({
      url: `${ENDPOINT.TECHNICIANS}/${technicianId}`,
      method: HttpMethod.PUT,
      body: technicianData
    })
});

export const DeleteTechnician = (technicianId: string) => ({
  name: "DeleteTechnician",
  handle: (): Promise<TechnicianResponse> =>
    apiCall<TechnicianResponse>({
      url: `${ENDPOINT.TECHNICIANS}/${technicianId}`,
      method: HttpMethod.DELETE
    })
});

export const TechnicianGroupedByShop = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `TechnicianGroupedByShop_${stringParams}`,
    handle: (): Promise<{ data: GroupedTechnician[] }> =>
      apiCall<{ data: GroupedTechnician[] }>({
        params,
        url: `${ENDPOINT.TECHNICIANS}/grouped-by-shop`,
        method: HttpMethod.GET
      })
  };
};

export const TechnicianById = (technicianId: number | string) => ({
  name: `TechnicianById_${technicianId}`,
  handle: (): Promise<TechnicianSingleResponse> =>
    apiCall<TechnicianSingleResponse>({
      url: `${ENDPOINT.TECHNICIANS}/${technicianId}`,
      method: HttpMethod.GET
    })
});

export const TechnicianConflicts = (params: {
  technicianId: number;
  startDate: string;
  endDate: string;
  excludeWorkflowId?: number;
}) => {
  const { technicianId, ...rest } = params;
  const stringParams = JSON.stringify(rest);
  return {
    name: `TechnicianConflicts_${technicianId}_${stringParams}`,
    handle: (): Promise<TechnicianConflictResponse> =>
      apiCall<TechnicianConflictResponse>({
        url: `${ENDPOINT.TECHNICIANS}/${technicianId}/conflicts`,
        method: HttpMethod.GET,
        params: {
          startDate: params.startDate,
          endDate: params.endDate,
          excludeWorkflowId: params.excludeWorkflowId
        }
      })
  };
};
